import { REHYDRATE } from 'redux-persist';
import { all, takeLatest } from 'redux-saga/effects';

import { authActions } from '../index';
import createPassword from './createPassword';
import edit from './edit';
import editCompany from './editCompany';
import forgotPassword from './forgotPassword';
import refreshProfile from './refreshProfile';
import refreshToken from './refreshToken';
import resetPassword from './resetPassword';
import signIn from './signIn';

const authSagas = all([
  takeLatest(REHYDRATE, refreshToken),
  takeLatest(REHYDRATE, refreshProfile),
  takeLatest(authActions.editCompanyRequest, editCompany),
  takeLatest(authActions.editRequest, edit),
  takeLatest(authActions.forgotPasswordRequest, forgotPassword),
  takeLatest(authActions.resetPasswordRequest, resetPassword),
  takeLatest(authActions.createPasswordRequest, createPassword),
  takeLatest(authActions.signInRequest, signIn),
]);

export default authSagas;
